import tmhRequest from '@/config/tmhRequest'

export default {
    searchPaymentReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/paymentreport/searchpaymentreportcount',
            method: 'post',
            data: data,
        })
    },
    searchPaymentReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/paymentreport/searchpaymentreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportPaymentReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/paymentreport/exportpaymentreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
    multiExportPaymentReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/paymentreport/multiexportpaymentreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
    repairPaymentReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/paymentreport/repairpaymentreport',
            method: 'get',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/paymentreport.js